import { render } from "./TroubleshootingTab.vue?vue&type=template&id=d8e31b32&scoped=true"
import script from "./TroubleshootingTab.vue?vue&type=script&lang=js"
export * from "./TroubleshootingTab.vue?vue&type=script&lang=js"

import "./TroubleshootingTab.vue?vue&type=style&index=0&id=d8e31b32&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8e31b32"]])

export default __exports__